import React, { useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const CollapsibleContainer = ({
  children,
  title,
  defaultExpanded = false,
  headerProps = {},
  contentProps = {},
  paperProps = {},
  titleVariant = "h6",
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const theme = useTheme();

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        mb: 2,
        ...paperProps.sx,
      }}
      {...paperProps}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          bgcolor: theme.palette.background.default,
          borderBottom: expanded
            ? `1px solid ${theme.palette.divider}`
            : "none",
          cursor: "pointer",
          "&:hover": {
            bgcolor: theme.palette.action.hover,
          },
          ...headerProps.sx,
        }}
        onClick={toggleExpand}
        {...headerProps}
      >
        <Typography variant={titleVariant} component="div">
          {title}
        </Typography>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            toggleExpand();
          }}
          sx={{ transform: expanded ? "rotate(0deg)" : "rotate(0deg)" }}
        >
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded} timeout="auto">
        <Box
          sx={{
            p: 2,
            ...contentProps.sx,
          }}
          {...contentProps}
        >
          {children}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default CollapsibleContainer;
